import script from "./uploadFile.vue?vue&type=script&lang=ts&setup=true&name=uploadFile"
export * from "./uploadFile.vue?vue&type=script&lang=ts&setup=true&name=uploadFile"

import "./uploadFile.vue?vue&type=style&index=0&id=6ee95545&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee95545"]])

export default __exports__